import { useSavingsGoals } from '../../hooks/useSavingsGoals'
import { useSales } from '../../hooks/useSales'
import { useExpenses } from '../../hooks/useExpenses'
import { usePrints } from '../../hooks/usePrints'
import { formatMoney } from '../../lib/format'
import { Card } from '../../components/ui'
import { computeProfitForPeriod } from '../../lib/profit'

export default function RecoupCard() {
  const { data: goals } = useSavingsGoals()
  const { data: sales } = useSales()
  const { data: expenses } = useExpenses()
  const { data: prints } = usePrints()

  if (!goals || !sales || !expenses || !prints) return null
  if (goals.length === 0) return null

  // Pick the first non-completed goal, or fall back to the first goal
  const goal = goals.find((g) => !g.completed_at) ?? goals[0]
  const startDate = goal.start_date

  // Filter to the goal's window + (when linked) to its printer.
  const rangeSales = sales.filter((s) => s.sale_date >= startDate)
  const rangeExpenses = expenses
    .filter((e) => e.expense_date >= startDate)
    .filter(
      (e) =>
        !goal.linked_printer_id ||
        e.printer_id === goal.linked_printer_id ||
        e.printer_id === null,
    )
  const rangePrints = prints
    .filter((p) => p.print_date >= startDate)
    .filter((p) => !goal.linked_printer_id || p.printer_id === goal.linked_printer_id)

  const profitSinceStart = computeProfitForPeriod({
    sales: rangeSales,
    expenses: rangeExpenses,
    prints: rangePrints,
  }).profit
  const target = Number(goal.target_amount)
  // Display: progress can't be negative — clamp at 0
  const progress = Math.max(0, profitSinceStart)
  const pct = Math.min(100, (progress / target) * 100)
  const inTheRed = profitSinceStart < 0

  return (
    <Card surface="hero" style={{ marginBottom: 'var(--space-4)' }}>
      <div style={{ fontSize: 'var(--font-size-xs)', opacity: 0.85, textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 }}>
        {goal.name}
      </div>
      <div style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700, margin: 'var(--space-1) 0', fontVariantNumeric: 'tabular-nums' }}>
        {formatMoney(progress)} / {formatMoney(target)}
      </div>
      <div style={{ background: 'rgba(255,255,255,0.25)', height: 6, borderRadius: 3, overflow: 'hidden', margin: 'var(--space-2) 0' }}>
        <div style={{ background: 'white', height: '100%', width: `${pct}%`, transition: 'width 300ms ease-out' }} />
      </div>
      <div style={{ fontSize: 'var(--font-size-xs)', opacity: 0.9 }}>
        {profitSinceStart >= target
          ? '🎉 Recouped!'
          : inTheRed
            ? `${formatMoney(-profitSinceStart)} in the red — need ${formatMoney(target - profitSinceStart)} from sales to break even and recoup`
            : `${formatMoney(target - profitSinceStart)} to go · ${Math.round(pct)}%`}
      </div>
    </Card>
  )
}
